import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { URLS } from '../../../shared/constant/interface';
import { formatNumber } from '../../../shared/utils/common';

@Component({
  selector: 'app-tiktok-fans',
  templateUrl: './tiktok-fans.component.html',
  styleUrls: ['./tiktok-fans.component.less'],
})
export class TiktokFansComponent implements OnInit {

static NAME = 'icc-msg-social-fans';

  // 粉丝总数
  fansCount: number;
  fansCountList: Array<string>;
  // 昨日新增粉丝数
  yIncreasedFans: number;
  yIncreasedFansList: Array<string>;
  // 昨日取关粉丝数
  /*   yUnfollowFans: number;
  yUnfollowFansList: Array<string>; */
  constructor(private route: ActivatedRoute, private http: _HttpClient, private cdr: ChangeDetectorRef) {}

  channelId: number;

  activeDayDistribution: Array<{
    item: string;
    value: number;
  }>;
  interestDistribution: Array<{
    item: string;
    value: number;
  }>;
  ageDistribution: Array<{
    item: string;
    value: number;
  }>;
  areaDistribution: Array<{
    item: string;
    value: number;
  }>;
  genderDistribution: Array<{
    item: string;
    value: number;
  }>;

  // 数据总量处理
  handleCount(count: any) {
    if (typeof count === 'string') {
      count = Number(count);
    }
    if (typeof count === 'number') {
      if (count > 10000) {
        const floorCount = Math.floor(count / 10000) + 'W+';
        const floorCountList = floorCount.split('');
        return floorCountList;
      } else {
        const numStrings = formatNumber(count);
        const countList = numStrings.split('');
        return countList;
      }
    }
  }

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    this.channelId = params.channelId;
    this.http.get(URLS.fetchTikTokFansIndexStatData.url + '/' + this.channelId).subscribe(res => {
      if (res.status === 0 && res.data) {
        this.fansCount = res.data.totalFans;
        this.fansCountList = this.handleCount(this.fansCount);
        this.yIncreasedFans = res.data.newFans;
        this.yIncreasedFansList = this.handleCount(this.yIncreasedFans);
        /*         this.yUnfollowFans = res.data.cancelFans;
        this.yUnfollowFansList = this.handleCount(this.yUnfollowFans); */
      }
    });

    this.http.get(URLS.fetchTikTokFansPortraitData.url + '/' + this.channelId).subscribe(res => {
      if (res.status === 0 && res.data) {
        this.activeDayDistribution = res.data.activeDayDistribution;
        this.interestDistribution = res.data.interestDistribution;
        this.ageDistribution = res.data.ageDistribution;
        this.areaDistribution = res.data.areaDistribution;
        this.genderDistribution = res.data.genderDistribution;
        // 强制更新检测
        this.cdr.detectChanges();
      }
    });
  }
}
